<app-header *ngIf="exibirConteudo"></app-header>

<ngx-spinner type="ball-clip-rotate">
  <div class="wrapper center">
    <div class="inner">
      <div><img class="bbpay-logo" src="../assets/images/logo_bbpay.svg" alt=""></div>
      <span class="spinner-text">Aguarde</span>
    </div>
  </div>
</ngx-spinner>

<div *ngIf="exibirConteudo">

  <div class="container box">

    <div class="logo-bb">
      <img src="../assets/images/logo_bb.svg" alt="">
    </div>

    <div class="row">

      <div class="col-30 card-left">

        <div class="container">

          <div class="content-top">

            <div class="card-title-one">
              <span>{{consultaPagamento?.denominacaoComercial}}</span>
            </div>

            <div class="info">

              <div>
                <label>Titular:</label>
                <span class="value">{{consultaPagamento?.subscritor}}</span>
              </div>

              <div>
                <label>{{consultaPagamento?.tipoPessoa === 'PF' ? 'CPF' : 'CNPJ'}}:</label>
                <span class="value">{{cpfCnpjFormatado | mask: mascaraDocumento}}</span>
              </div>

            </div>

            <div class="info">

              <div>
                <label>Data da Venda:</label>
                <span class="value">{{consultaPagamento?.dataVenda | date: 'dd/MM/yyyy'}}</span>
              </div>

              <div class="item">
                <label>Valor da Garantia:</label>
                <span class="value">{{consultaPagamento?.valorTotal | currency}}</span>
              </div>
            </div>

            <div class="item">
              <label>Forma de Cobrança:</label>
              <span class="value">{{descricaoFormaCobranca}}</span>
            </div>

          </div>

          <div class="logo-group">
            <label>Bandeiras aceitas:</label>

            <div *ngFor="let bandeira of bandeiras" class="logo">
              <img [src]="bandeira.src" alt="Imagem" />
            </div>
          </div>

        </div>

      </div>

      <div class="col-70 card-right">
        <div class="container">
          <form [formGroup]="pagamentoForm">

            <div class="row">

              <div class="card-title-two">
                <i class="fa fa-exclamation-circle"></i>
                <span>Apenas o cartão do Titular/Subscritor deverá ser preenchido.</span>
              </div>

              <!-- <div class="col-70">
                <label for="parcela">Parcelas</label>
                <p>{{consultaPagamento?.quantidade}}x {{consultaPagamento?.valor | currency}}</p>
              </div> -->

              <div class="col-50">
                <label for="numeroCartao">Número do Cartão</label>
                <input type="text" id="numeroCartao" name="numeroCartao" formControlName="numeroCartao"
                  class="{{numeroCartao?.length == 16 && !this.obterBandeiraCartao() ? 'obrigatorio': '' }}"
                  mask="0000 0000 0000 0000" (keyup)="validarBandeiraCartao($event)">
              </div>

              <div class="col-50 ">
                <label>Bandeira</label>

                <div class="credit-card-logo" *ngIf="obterBandeiraCartao()">
                  <img src="../../assets/images/credit-card/logo_ccvisa.svg" *ngIf="obterBandeiraCartao() === 'Visa'"
                    alt="Visa">
                  <img src="../../assets/images/credit-card/logo_ccelo.svg" *ngIf="obterBandeiraCartao() === 'Elo'"
                    alt="Cielo">
                  <img src="../../assets/images/credit-card/logo_ccmastercard.svg"
                    *ngIf="obterBandeiraCartao() === 'Master'" alt="Master">
                </div>

              </div>

              <div class="col-70">
                <label for="titularCartao">Nome como está escrito no cartão</label>
                <input type="text" id="titularCartao" name="titularCartao" formControlName="titularCartao">
              </div>

              <div class="col-70">

                <div class="row">

                  <div class="col-50">
                    <label for="dataValidade">Validade (mm/aa)</label>
                    <input type="text" id="dataValidade" name="dataValidade" formControlName="dataValidade"
                      class="{{pagamentoForm.get('dataValidade')?.hasError('dateValidator')? 'obrigatorio': ''}}"
                      mask="00/00">

                    <div class="validacao-campo">
                      <span *ngIf="pagamentoForm.get('dataValidade')?.hasError('dateValidator')">
                        Data de Vencimento Inválida!
                      </span>
                    </div>

                  </div>

                  <div class="col-50">
                    <label for="cvv">CVV</label>
                    <input type="text" id="cvv" name="cvv" formControlName="cvv" mask="000">
                  </div>

                </div>
              </div>

              <div class="col-70">
                <div class="row">
                  <div class="col-50 d-flex flex-column">
                    <label for="numeroParcelasCartao">Parcelas*</label>
                    <select #opcaoParcela id="numeroParcelasCartao" name="numeroParcelasCartao" formControlName="numeroParcelasCartao"
                      (change)="dadosParcela(opcaoParcela.value)" class="combo-parcelas">
                      <option disabled selected>--</option>
                      <option [label]="parcela.opcaoParcelamento" *ngFor="let parcela of listaParcelas"
                        [value]="parcela.qtdParcelamento">
                        {{parcela.opcaoParcelamento}}</option>
                    </select>
                  </div>
                  <div class="col-50"></div>
                </div>
              </div>

            </div>


            <div class="rounded-button">
              <input type="button" value="Confirmar Pagamento" class="btn btn-submit"
                [disabled]="pagamentoForm.valid && obterBandeiraCartao() ? false : true" (click)="confirmarPagamento()">
            </div>

          </form>
        </div>
      </div>

    </div>
  </div>

</div>

<app-footer *ngIf="exibirConteudo"></app-footer>
